module.exports = __webpack_public_path__ + "static/media/remove-filter.c8d4677d.svg";